<template>
  <div class="footer-border-lines w-100">
    <div class="d-flex top-lines">
      <div class="line bg-primary" />
      <div class="line bg-dark-blue" />
    </div>
    <div class="line bg-secondary"></div>
  </div>
</template>

<script>
export default {

}
</script>
